module.exports = __webpack_public_path__ + "cc9bbb8699591933b3ebe18642585161.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/UC-Santa-Cruz-Genomics-Inst_090314.png
// module id = 1338
// module chunks = 0